(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dba-art-break"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.CSS && CSS.supports('animation-timeline', 'scroll()')) return;
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) return;
  var sections = document.querySelectorAll('.dba-art-break');
  if (!sections.length) return;
  function onScroll() {
    sections.forEach(function (section) {
      var media = section.querySelector('.dba-art-break__media');
      if (!media) return;
      var rect = section.getBoundingClientRect();
      var progress = 1 - (rect.bottom / (window.innerHeight + rect.height));
      var offset = (progress - 0.5) * 16;
      media.style.transform = 'translateY(' + offset + '%)';
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dba-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Check property existence (not value) — more reliable cross-browser
  if (window.CSS && CSS.supports('animation-timeline', 'none')) return;
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq && mq.matches) return;
  var desktop = window.matchMedia('(min-width: 750px)');
  if (!desktop.matches) return;
  var media = document.querySelector('.dba-hero__media');
  if (!media) return;
  function onScroll() {
    var ratio = Math.min(window.scrollY / window.innerHeight, 1);
    media.style.transform = 'translateY(' + (-ratio * 12) + '%)';
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // prime on load so the effect is ready from frame 0
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dba-product-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('dba-sticky-bar');
    if (!bar) return;

    // Show bar once the product form scrolls out of view
    var form = document.getElementById('product-form');
    if (!form) {
      // Fallback: show after 400px scroll
      form = document.querySelector('[data-product-form], product-form, .product-form');
    }
    if (!form) return;

    bar.removeAttribute('hidden');

    var ticking = false;
    var update = function () {
      var rect = form.getBoundingClientRect();
      var belowFold = rect.bottom < 0;
      if (belowFold) {
        bar.classList.add('dba-sticky-bar--visible');
      } else {
        bar.classList.remove('dba-sticky-bar--visible');
      }
      ticking = false;
    };

    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });

    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
